export default __webpack_public_path__ + "static/media/news.14070d8d.svg";